import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function DiceIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.6 2A5.6 5.6 0 0 0 2 7.6v16.8C2 27.5 4.5 30 7.6 30h16.8c3.1 0 5.6-2.5 5.6-5.6V7.6C30 4.5 27.5 2 24.4 2H7.6ZM9 25.8a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6ZM11.8 9a2.8 2.8 0 1 1-5.6 0 2.8 2.8 0 0 1 5.6 0ZM23 25.8a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6ZM25.8 9a2.8 2.8 0 1 1-5.6 0 2.8 2.8 0 0 1 5.6 0ZM16 18.8a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
